import Cookies from 'js-cookie';
import GlobalConfig from '@/config/globalConfig';

const globalUtils = {
    /** -------------------------
     *  ✅ URL 参数操作
     * -------------------------- */
    getQueryParam(name, url = window.location.href) {
        name = name.replace(/[[]]/g, '\\$&')
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        const results = regex.exec(url)
        if (!results) return null
        if (!results[2]) return ''
        return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },

    setQueryParam(name, value) {
        const url = new URL(window.location.href)
        url.searchParams.set(name, value)
        window.history.replaceState({}, '', url.toString())
    },

    deleteQueryParam(name) {
        const url = new URL(window.location.href)
        url.searchParams.delete(name)
        window.history.replaceState({}, '', url.toString())
    },

    /** -------------------------
     *  ✅ Cookie 操作
     * -------------------------- */
    setCookie(name, value, days = 7) {
        Cookies.set(name, value, { expires: days })
    },

    getCookie(name) {
        return Cookies.get(name)
    },

    removeCookie(name) {
        Cookies.remove(name)
    },

    login() {
        window.location.href = GlobalConfig.loginURL +
            "?client_id=" + GlobalConfig.loginClientID +
            "&redirect_uri=" + GlobalConfig.loginRedirectURL +
            "&state=1234" + "&response_type=code";
    },
    logout() {

    }
}

export default globalUtils